import { render } from "./Account.vue?vue&type=template&id=511af0ee&scoped=true&ts=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=511af0ee&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511af0ee"]])

export default __exports__